module.exports = __webpack_public_path__ + "fonts/fa-solid-900.289a6bf.woff2";